import { VenueFilterData, VenueSortData } from '../dto/EntityRepository';
import { SortDirection, VenueSortOrder, VenueType } from '../enum/EnumRepository';

export const getDefaultVenueSortData = (): VenueSortData => ({
  sort: VenueSortOrder.NAME,
  direction: SortDirection.ASC,
});

export const getDefaultVenueFilterData = (): VenueFilterData => ({
  venueType: Object.values(VenueType).reduce((acc, type) => {
    acc[type] = true;
    return acc;
  }, {} as { [key in VenueType]: boolean }),
  admissionFree: false,
  openToday: false,
  tagIds: [],
  districts: [],
});

function appendVenueFilterParams(p: URLSearchParams, filter: VenueFilterData) {
  const types = Object.values(VenueType);
  const selectedTypes = types.filter((type) => filter.venueType[type]);
  selectedTypes.forEach((type) => p.append('types', type));

  if (filter.admissionFree) {
    p.set('admissionFree', 'true');
  }
  if (filter.openToday) {
    p.set('openToday', 'true');
  }

  filter.tagIds.forEach((tagId) => p.append('tagIds', String(tagId)));

  (filter.districts ?? [])
    .map((district) => district.trim())
    .filter(Boolean)
    .forEach((district) => p.append('districts', district));
}

export function buildVenueListParams(
  metaData: { page: number; size: number; sortData: VenueSortData },
  filter: VenueFilterData,
): URLSearchParams {
  const p = new URLSearchParams();

  p.set('page', String(metaData.page));
  p.set('size', String(metaData.size));
  p.set('sortBy', metaData.sortData.sort);
  p.set('direction', metaData.sortData.direction);
  appendVenueFilterParams(p, filter);

  return p;
}

export function buildVenueIndexParams(
  sortData: VenueSortData,
  filter: VenueFilterData,
): URLSearchParams {
  const p = new URLSearchParams();
  p.set('sortBy', sortData.sort);
  p.set('direction', sortData.direction);
  appendVenueFilterParams(p, filter);
  return p;
}
